import React, { useId, useState } from 'react';
import { FaMinus, FaPlus } from 'react-icons/fa';
import ReactTooltip from 'react-tooltip';
import {
    mailerLogStatusPillClass,
    mailerLogStatusTooltipType,
} from '~/enums/mailersLogStatus';
import './styles.css';

function mailsTooltipMultiline(mail: unknown): string {
    if (mail == null) return '';
    const s = String(mail).trim();
    if (!s) return '';
    return s.split(/\s*,\s*/).filter(Boolean).join('\n');
}

interface Props {
    hash: string;
    type: string;
    typeName: string;
    dateRef: string;
    date: string;
    user: string;
    data: any;
}

const Logs: React.FC<Props> = (props) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const mailTooltipId = useId().replace(/:/g, '');

    return (
        <>
            <div className='log_line'>
                <div className="header">
                    <div className="hash">
                        <label>Hash</label>
                        <span>{props.hash.substring(0, 8)}</span>
                    </div>

                    <div className="type">
                        <label>Tipo</label>
                        <span>{props.typeName}</span>
                    </div>

                    <div className="dates">
                        <label>Referência</label>
                        <span>{props.dateRef}</span>
                    </div>

                    <div className="dates">
                        <label>Data do Envio</label>
                        <span>{props.date.substring(0, 10)}</span>
                    </div>

                    <div className="user">
                        <label>Usuário</label>
                        <span>{props.user}</span>
                    </div>

                    <button className="open" onClick={() => setIsOpen(!isOpen)}>
                        { !isOpen ? <FaPlus /> : <FaMinus /> }
                    </button>
                </div>

                <div className={`data ${isOpen ? '' : 'none'}`}>
                    {
                        props.data &&
                            props.data.map((el: any) => {
                                const mailTip = mailsTooltipMultiline(el.mail);
                                return (
                                    <div className="data_line" key={`data_line_${el.id}`}>
                                        <div
                                            className={`status ${mailerLogStatusPillClass(el.status)}`}
                                            data-for="tooltip_status"
                                            data-tip={el.message}
                                            data-type={mailerLogStatusTooltipType(el.status)}
                                        ></div>
                                        <div className="unit">{el.unit}</div>
                                        <div
                                            className="mail"
                                            data-for={mailTip ? mailTooltipId : undefined}
                                            data-tip={mailTip || undefined}
                                        >
                                            {el.mail}
                                        </div>
                                        <div className="message">{el.message}</div>
                                    </div>
                                );
                            })
                    }
                </div>
            </div>

            <ReactTooltip
                id="tooltip_status"
                place="right"
                effect="solid"
                type="info"
            />
            <ReactTooltip
                id={mailTooltipId}
                place="top"
                effect="solid"
                type="dark"
                multiline
            />
        </>
    );
};

export default Logs;